module.exports = __webpack_public_path__ + "img/088ed91.jpg";